import React from 'react';

import Link from 'shared/components/common/link';
import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext';
import { useRestaurantRoutes } from 'shared/components/common/restaurant_routes/RestaurantRoutesContext';

const Breadcrumbs = ({ name }: { name: string }) => {
  const { ecommPath } = useRestaurantRoutes();
  const { restaurant: siteRestaurant } = useRestaurant();

  // pull the ecomm store nav item name from the site content to keep the breadcrumbs consistent with the Nav
  const storeHome = siteRestaurant?.content?.nonPrimaryCtas?.find(cta => cta.link === ecommPath)?.text || 'Store';
  const crumbs = [];

  crumbs.push({
    name,
    path: '' // the menu item breadcrumb isn't clickable
  });

  const numCrumbs = crumbs.length;
  const crumbNodes = crumbs.map((crumb, i) => {
    return (
      <React.Fragment key={i}>
        <li className="crumb slash">/</li>
        <li className="crumb">{i < numCrumbs - 1 ? <Link href={crumb.path} sameTab>{crumb.name}</Link> : crumb.name}</li>
      </React.Fragment>);
  });

  // prepend the crumbs with the "Home" text.
  crumbNodes.unshift(<li className="crumb" key={-1}><Link href={ecommPath} sameTab>{storeHome}</Link></li>);

  return (
    <div className="breadcrumbs">
      <ul>
        {crumbNodes}
      </ul>
    </div>
  );
};

export default Breadcrumbs;
